let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hgAfI")).then(() => parcelRequire('gTjY8'));